import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import ModalBasicLayout from "../../Modal/ModalBasicLayout";
import ContainerModalActions from "../../Containers/ContainerModalActions";
import TextField from "../../Form/TextField";
import { useTranslationApp } from "../../../lib/i18next";
import {
  BUTTON_CANCEL,
  BUTTON_SAVE,
  FIELD_REQUIRED,
  FIELD_URL_REPEATED,
  FIELD_URL_VALID,
  GOOGLE_WEBPAGE_ADD_TITLE,
  GOOGLE_WEBPAGE_EDIT_TITLE,
  GOOGLE_WEBPAGE_URL_LABEL,
} from "../../../i18n/keysTranslations";
import { REGEX_URL } from "../../../utils/regex";

const WebpageModal = ({
  modalOpen,
  onCloseModal,
  onSubmit: onSubmitModal = () => {},
  currentWebpages = [],
  initialData = null,
}) => {
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      url: initialData?.value || "",
    },
  });

  const { t } = useTranslationApp();

  const onSubmit = ({ url }) => {
    const trimmedUrl = url.trim();

    if (!REGEX_URL.test(encodeURI(trimmedUrl))) {
      setError("url", { message: t(FIELD_URL_VALID) });
      return;
    }

    const isDuplicate = currentWebpages.some(
      (wp) =>
        wp.value?.trim().toLowerCase() === trimmedUrl.toLowerCase() &&
        (!initialData || wp.id !== initialData.id)
    );
    if (isDuplicate) {
      setError("url", { message: t(FIELD_URL_REPEATED) });
      return;
    }

    onSubmitModal(trimmedUrl);
    onCloseModal();
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth={true}
      scroll="paper"
      maxWidth="xs"
      title={t(
        initialData ? GOOGLE_WEBPAGE_EDIT_TITLE : GOOGLE_WEBPAGE_ADD_TITLE
      )}
    >
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
      >
        <TextField
          name="url"
          label={t(GOOGLE_WEBPAGE_URL_LABEL)}
          fullWidth
          variant="filled"
          control={control}
          rules={{
            required: { value: true, message: t(FIELD_REQUIRED) },
          }}
          errors={errors}
        />
        <ContainerModalActions
          hasPadding={false}
          propsSecondaryButton={{
            showButton: true,
            onClick: onCloseModal,
            text: BUTTON_CANCEL,
          }}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_SAVE,
            type: "button",
            onClick: handleSubmit(onSubmit),
          }}
        />
      </Box>
    </ModalBasicLayout>
  );
};

export default WebpageModal;
